/**
 * Colour swatches for product cards.
 *
 * The API exposes colours only as free-text attribute values ("Anodized Aluminum",
 * "Safety Yellow", ...) — there is no hex or variant data — so the swatch row is
 * derived by matching those strings against this table. Shared by the homepage
 * marketing card (featured-product-card) and the account Overview "Saved Items"
 * card so the two show the same colours for the same product.
 */
export const SWATCH_COLORS: Record<string, string> = {
  white: '#FFFFFF', black: '#0A0A0A', clear: '#EEF1F4', translucent: '#EEF1F4',
  red: '#DC3545', green: '#28A745', blue: '#57A9D0', navy: '#2A4E6B',
  teal: '#2AA198', yellow: '#FFD54F', orange: '#FF9F40', gray: '#777777',
  grey: '#777777', silver: '#C0C4C8', aluminum: '#B8BCC0', chrome: '#C0C4C8',
  brown: '#8B5A2B', tan: '#D2B48C', beige: '#E8DCC4', purple: '#6F42C1',
  pink: '#E83E8C', gold: '#D4AF37', bronze: '#CD7F32', ivory: '#FFFFF0',
};

/** First hex in SWATCH_COLORS whose key appears in `name`; null when nothing matches. */
export function nameToHex(name: string): string | null {
  const s = (name || '').toLowerCase();
  for (const key of Object.keys(SWATCH_COLORS)) {
    if (s.includes(key)) return SWATCH_COLORS[key];
  }
  return null;
}

/** Deduped swatch hexes from the product's Color attribute(s); [] when none map. */
export function swatchesFor(item: any, max = 7): string[] {
  const attrs = item?.attributesDTOs || [];
  const out: string[] = [];
  for (const a of attrs) {
    if ((a?.attributeName || '').toLowerCase() !== 'color') continue;
    const hex = nameToHex(a.attributeValue);
    if (hex && !out.includes(hex)) out.push(hex);
  }
  return out.slice(0, max);
}
